import { urlContenidos, urlTokenIframe } from "../../constants/urls";
import { createAction } from "redux-actions";

export const CONTENIDOS_HAS_ERRORED = "CONTENIDOS_HAS_ERRORED";
export const CONTENIDOS_IS_LOADING = "CONTENIDOS_IS_LOADING";
export const SET_CONTENIDOS = "SET_CONTENIDOS";
export const SET_SLIDERS_HOME = "SET_SLIDERS_HOME";
export const TOKE_IFRAME = "TOKE_IFRAME";
export const ERROR_IFRAME_TOKEN = "ERROR_IFRAME_TOKEN";
export const setSliderHome = createAction("SET_SLIDERS_HOME");
export const setContenidos = createAction(SET_CONTENIDOS);
const contenidosHasError = createAction(CONTENIDOS_HAS_ERRORED);
const contenidosIsLoading = createAction(CONTENIDOS_IS_LOADING);
const setTokenIframe = createAction(TOKE_IFRAME);
const setErrorIframe = createAction(ERROR_IFRAME_TOKEN)
export const SET_LINK_INCENTIVOS = createAction("SET_LINK_INCENTIVOS");

export const contenidosFetch = (seccion, id) => async (dispatch, getState) => {
  const sliderhome = getState().datosContenido.slidersHome;
  //console.log("sliderhome",sliderhome)
  var url = `${urlContenidos}${seccion}&id=${id}`;
  dispatch(contenidosIsLoading());
  await fetch(url)
    .then((response) => response.json())
    .then((data) => {
      console.log("DATA TEST: ", data);
      const transaccion = data.transaccion;      
      if (transaccion) {
        var contenidos = [];
        contenidos = data.informacion;
        dispatch(setContenidos(contenidos));
        if (sliderhome.length === 0) {
          let ObtenerSeccion2 = "";
          if (contenidos.paginas !== undefined && contenidos.paginas !== "") {
            ObtenerSeccion2 = contenidos.paginas.filter(
              (objeto) => parseInt(objeto.seccion) === 2
            );
            //console.log("ObtenerSeccion2ObtenerSeccion2",ObtenerSeccion2)                      
          }        
          dispatch(setSliderHome(ObtenerSeccion2));
        }

        //Agregar ULR incentivos
        if (contenidos.paginas !== undefined && contenidos.paginas !== "") {
          let Array=contenidos.paginas;
          let resURl = Array.find((Array) => parseInt(Array.seccion) === 6);          
          if (resURl && resURl.contenido) {
            dispatch(SET_LINK_INCENTIVOS(resURl.contenido.url_redireccion));                       
          }
        }
        



      } else {
        dispatch(contenidosHasError());
      }
    })
    .catch(() => {
      dispatch(contenidosHasError());
    });
};


export const tokenIframe = async() => {
  const url = urlTokenIframe;
  
  try{

    const data = await fetch(url);
    let response = await data.json();
    localStorage.setItem('tokenIframe', response.token);
    return response.token;

  }catch(e){
    return null;
  
  }

}